module.exports = "<a [href]=\"\" (click)=\"loadStaticUserRoles()\" class=\"btn btn-info btn-fill pe-7s-refresh-2\" download>\n  Load UserRoles\n</a>\n"